import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { ProductSellerName } from '@/checkout-instore-legacy/components/Commons/ProductSummary/ProductName/ProductSellerName'
import { Grid, Text, Skeleton, csx } from '@vtex/admin-ui'

export type PackageInfoProps = {
  sellerId: string
  children?: ReactNode
}

export const PackageInfo = (props: PackageInfoProps) => (
  <div className={csx({ marginTop: '$space-2' })}>
    <ProductSellerName sellerId={props.sellerId} />
    <Grid
      rowGap="1"
      columnGap="2"
      templateColumns="auto 1fr"
      className={csx({ marginTop: '$space-4' })}
    >
      {props.children}
    </Grid>
  </div>
)

export type PackageInfoRowProps = {
  labelId: string
  value: string | ReactNode
}

export const PackageInfoRow = (props: PackageInfoRowProps) => (
  <>
    <Text
      variant="action1"
      className={csx({ color: '$secondary', fontWeight: 'bold' })}
    >
      <FormattedMessage id={props.labelId} />
      {':'}
    </Text>
    <Text
      data-testid={props.labelId}
      variant="action2"
      className={csx({
        display: 'flex',
        alignItems: 'center',
        color: '$secondary',
        marginLeft: '0.25rem',
      })}
    >
      {props.value}
    </Text>
  </>
)

export const PackageInfoSkeleton = () => (
  <Skeleton
    data-testid="package-info-skeleton"
    className={csx({ height: '14px', width: '120px' })}
  />
)
